export default __webpack_public_path__ + "static/media/remedyHeader.1807012f.png";